/* KBW Announcement Bar — Alpine components.
   Registered on `alpine:init`, the same hook the theme uses for its own components.
   Values are read from data-* attributes so nothing has to be inlined into an
   x-data expression (a quoted string there would break out of the attribute). */

document.addEventListener('alpine:init', function () {
  if (!window.Alpine) return;

  /* Copy a coupon code to the clipboard, with a fallback for non-secure contexts. */
  window.Alpine.data('kbwCopyCode', function () {
    return {
      copied: false,
      code: '',

      /* Read the value in init(), where $el is the component root. Inside copy()
         the handler runs on the button, so $el would point at the button instead. */
      init: function () {
        this.code = (this.$el.dataset.code || '').trim();
      },

      copy: function () {
        var self = this;
        var text = this.code;
        if (!text) return;

        var done = function () {
          self.copied = true;
          setTimeout(function () { self.copied = false; }, 2000);
        };

        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(text).then(done).catch(function () {
            self.legacyCopy(text, done);
          });
        } else {
          this.legacyCopy(text, done);
        }
      },

      legacyCopy: function (text, done) {
        var el = document.createElement('textarea');
        el.value = text;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        try {
          document.execCommand('copy');
          done();
        } catch (e) {
          /* clipboard unavailable — the code stays visible on screen anyway */
        }
        document.body.removeChild(el);
      }
    };
  });

  /* Countdown to a deadline. The deadline is resolved server side in the shop's
     time zone and handed over as epoch milliseconds, so no date parsing happens here. */
  window.Alpine.data('kbwCountdown', function () {
    return {
      end: 0,
      d: '0',
      h: '00',
      m: '00',
      s: '00',
      expired: false,
      timer: null,

      init: function () {
        this.end = parseInt(this.$el.dataset.end, 10) || 0;
        this.tick();
        var self = this;
        this.timer = setInterval(function () { self.tick(); }, 1000);
      },

      destroy: function () {
        if (this.timer) clearInterval(this.timer);
      },

      pad: function (n) {
        return n < 10 ? '0' + n : String(n);
      },

      tick: function () {
        var diff = this.end - Date.now();
        if (diff <= 0) {
          this.expired = true;
          if (this.timer) clearInterval(this.timer);
          return;
        }
        this.d = String(Math.floor(diff / 86400000));
        this.h = this.pad(Math.floor((diff % 86400000) / 3600000));
        this.m = this.pad(Math.floor((diff % 3600000) / 60000));
        this.s = this.pad(Math.floor((diff % 60000) / 1000));
      }
    };
  });
});
